<google-pay-button [environment]="current_env" [buttonColor]="buttonColor" [buttonType]="buttonType" [buttonSizeMode]="isCustomSize ? 'fill' : 'static'" [paymentRequest]="paymentRequest"
    (loadpaymentdata)="onLoadPaymentData($event)">
</google-pay-button>